import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { LinkProps } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import SecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Button, { ButtonProps } from '@material-ui/core/Button';
// import Clear from '@material-ui/icons/Clear';
// import Check from '@material-ui/icons/Check';
import PageTitle from '../Common/PageTitle';
import HashLink from '../Common/HashLink';
import { getBaseUrl } from '../../utils';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    secondary: {
        paddingRight: '48px',
    },
    button: {
        margin: '10px 0px',
    },
    label: {
        padding: '16px',
    },
});

interface Props {
    match: {
        path: string;
    };
    location: {
        hash: string;
    };
    classes: {
        container: string;
        secondary: string;
        button: string
        label: string;
    }
}

class AdminSettings extends React.Component<Props, any> {
  	render() {
        const { classes } = this.props;
        
        const MailLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/mail`} {...props} />
        const TwitterLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/twitter`} {...props} />
        const FacebookLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/facebook`} {...props} />
        const GoogleLink = (props: LinkProps & ButtonProps)  => <HashLink to={`${this.props.match.path}/google`} {...props} />

        // const CheckIcon = <Check fontSize="large" color="primary" />
        // const ClearIcon = <Clear fontSize="large" color="error" />

        return (
            <div className={classes.container}>
                <PageTitle title={'Settings'} back={`${getBaseUrl(this.props.match.path)}${this.props.location.hash}`} />
                <List>
                    <ListItem classes={{ secondaryAction: classes.secondary }}>
                        <Button
                            disabled
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            component={MailLink}
                            classes={{
                                root: classes.button,
                                label: classes.label,
                            }}
                        >
                            <Typography variant="h6" color="inherit" align="center">Mail Chimp</Typography>
                        </Button>
                        {/* <SecondaryAction>{CheckIcon}</SecondaryAction> */}
                    </ListItem>
                    <ListItem classes={{ secondaryAction: classes.secondary }}>
                        <Button
                            disabled
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            component={TwitterLink}
                            classes={{
                                root: classes.button,
                                label: classes.label,
                            }}
                        >
                            <Typography variant="h6" color="inherit" align="center">Twitter Credentials</Typography>
                        </Button>
                        {/* <SecondaryAction>{CheckIcon}</SecondaryAction> */}
                    </ListItem>
                    <ListItem classes={{ secondaryAction: classes.secondary }}>
                        <Button
                            disabled
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            component={FacebookLink}
                            classes={{
                                root: classes.button,
                                label: classes.label,
                            }}
                        >
                            <Typography variant="h6" color="inherit" align="center">FaceBook Credentials</Typography>
                        </Button>
                        {/* <SecondaryAction>{ClearIcon}</SecondaryAction> */}
                    </ListItem>
                    <ListItem classes={{ secondaryAction: classes.secondary }}>
                        <Button
                            disabled
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            component={GoogleLink}
                            classes={{
                                root: classes.button,
                                label: classes.label,
                            }}
                        >
                            <Typography variant="h6" color="inherit" align="center">Google Credentials</Typography>
                        </Button>
                        {/* <SecondaryAction>{ClearIcon}</SecondaryAction> */}
                    </ListItem>
                </List>
            </div>
        )
	}
}

export default withStyles(jss)(AdminSettings);



// WEBPACK FOOTER //
// ./src/components/Admin/AdminSettings.tsx